module.exports = __webpack_public_path__ + "static/media/slogan_rim.dcf01b0f.png";